<template>
  <div class="form-detail">
    <div class="d-flex justify-content-between">
      <h1 v-if="isProcessed">Lịch sử chăm sóc</h1>
      <h1 v-else>Lịch hẹn</h1>
      <b-link
        class="font-size-16 btn btn-outline-success mb-2 btn-sm"
        style="width: 180px; font-size: 12px !important"
        @click="addJob"
        v-if="isShowAdd"
      >
        <i class="bx bx-plus-circle"></i> Thêm công việc
      </b-link>
    </div>
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-left">Công việc</th>
            <th scope="col" class="text-left">Kết quả</th>
            <th scope="col" class="text-left">Trạng thái</th>
            <th scope="col" class="text-left">Nhân viên chăm sóc</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index">
          <tr class="table-row">
            <td align="left">
              <p><b>Mục đích: </b>{{ item.purposes }}</p>
              <p>
                <b>Thời gian dự kiến: </b>{{ item.startTime | formatDate('HH:mm DD/MM/YYYY') }} -
                {{ item.endTime | formatDate('HH:mm DD/MM/YYYY') }}
              </p>
              <p><b>Điểm hẹn: </b> {{ item.address }}</p>
            </td>
            <td align="left">
              <p v-if="item.resultDisplay"><b>Kết quả: </b>{{ item.resultDisplay }}</p>
              <p v-if="item.timeFinish">
                <b>Thời gian hoàn thành: </b> {{ item.timeFinish | formatDate }}
              </p>
            </td>
            <td align="center">
              {{ item.statusWkcldr | transformData(Config.statusWkcldr) }}
            </td>
            <td align="left">
              <span v-if="item.saleInfo"
                >{{ item.saleInfo.name }} - {{ item.saleInfo.userName }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { LeadsService } from '@/services/lead.service'
  export default {
    props: ['id', 'purposeType', 'isProcessed', 'isShowAdd'],
    data() {
      return {
        Config,
        items: [],
      }
    },
    async created() {
      if (this.isProcessed === true) {
        this.items = await LeadsService.mcTaskProcessed(this.id).then(s => s.data)
      } else {
        this.items = await LeadsService.mcTaskNotProcess(this.id).then(s => s.data)
      }
    },

    methods: {
      addJob() {
        if (this.purposeType === 'LEAD')
          this.$router.push({
            path: `/calendar/add?leadId=${this.id}&purposeType=${this.purposeType}&statusWkcldr=PROCESSED`,
          })
        else
          this.$router.push({
            path: `/calendar/add?customerId=${this.id}&purposeType=${this.purposeType}`,
          })
      },
    },
  }
</script>

<style scoped></style>
